import { createRouter,createWebHashHistory } from "vue-router";
import store from '@/store'
import util from '@/util/util'

// 路由规则
const routes = [
	{
		path: '/',
		redirect: '/login',
        meta: {
            title: '青穗网登录1'
        }
	},
    {
        name: '登录',
        path:'/login',
        component: () => import('@/pages/login/index.vue'),
        meta: {
            title: '青穗网登录2'
        }
    },

    {
        name: '登录',
        path:'/token/:token/:number/:url',
        component: () => import('@/pages/login/token.vue'),
        meta: {
            title: '青穗网登录3'
        }
    },

    // 城市
    {

        meta: {
            title: '青穗网-城市-管理端'
        },
        path:'/area',
        component: () => import('@/pages/area/home.vue'),
        children: [

            {
                // '指标',
                path: 'other/kpi/kpi',
                component: () => import('@/pages/area/other/kpi/kpi.vue'),
                meta: {
                    title: '城市-业绩指标'
                },
            },

            // --------------------------------------------------

            {
                // '提成月',
                path: 'other/ti/tiM',
                component: () => import('@/pages/area/other/ti/tiM.vue'),
                meta: {
                    title: '城市-提成记录'
                },
            },

            {
                // '提成日',
                path: 'other/ti/tiD/:batch_y/:batch_m',
                component: () => import('@/pages/area/other/ti/tiD.vue'),
                meta: {
                    title: '城市-提成记录'
                },
            },

            {
                // '提成店铺',
                path: 'other/ti/tiS/:batch_y/:batch_m/:batch_d',
                component: () => import('@/pages/area/other/ti/tiS.vue'),
                meta: {
                    title: '城市-提成记录'
                },
            },

            {
                // '提成品',
                path: 'other/ti/tiR/:batch_y/:batch_m/:batch_d/:batch_s',
                component: () => import('@/pages/area/other/ti/tiR.vue'),
                meta: {
                    title: '城市-提成记录'
                },
            },

            // --------------------------------------------------

            {
                // '分拣人员',
                path: 'other/counts/counts',
                component: () => import('@/pages/area/other/counts/counts.vue'),
                meta: {
                    title: '城市-分拣记录'
                },
            },

            {
                // '分拣人员',
                path: 'other/counts/news',
                component: () => import('@/pages/area/other/counts/news.vue'),
                meta: {
                    title: '城市-分拣记录'
                },
            },

            // --------------------------------------------------

            {
                // '订单人员',
                path: 'order/log/shop/shop',
                component: () => import('@/pages/area/order/log/shop/shop.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单记录',
                path: 'order/log/shop/rule/:uid/:batch',
                component: () => import('@/pages/area/order/log/shop/rule.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单记录',
                path: 'order/log/shop/rule/:uid/:batch/:rid',
                component: () => import('@/pages/area/order/log/shop/rule.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            // --------------------------------------------------

            {
                // '订单人员',
                path: 'order/log/ye/ye',
                component: () => import('@/pages/area/order/log/ye/ye.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单人员',
                path: 'order/log/ye/shop/:yid/:batch',
                component: () => import('@/pages/area/order/log/ye/shop.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单人员',
                path: 'order/log/ye/shop/:yid/:batch/:rid',
                component: () => import('@/pages/area/order/log/ye/shop.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单记录',
                path: 'order/log/ye/rule/:yid/:batch',
                component: () => import('@/pages/area/order/log/ye/rule.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单记录',
                path: 'order/log/ye/rule/:yid/:batch/:rid',
                component: () => import('@/pages/area/order/log/ye/rule.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            // --------------------------------------------------

            {
                // '订单人员',
                path: 'order/log/rule/rule',
                component: () => import('@/pages/area/order/log/rule/rule.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单人员',
                path: 'order/log/rule/shop/:rid/:batch',
                component: () => import('@/pages/area/order/log/rule/shop.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

            {
                // '订单人员',
                path: 'order/log/rule/ye/:rid/:batch',
                component: () => import('@/pages/area/order/log/rule/ye.vue'),
                meta: {
                    title: '城市-订单记录'
                },
            },

        ],
    },

    // 仓库
    {

        meta: {
            title: '青穗网-仓库-管理端'
        },
        path:'/granary',
        component: () => import('@/pages/granary/home.vue'),
        children: [
            {
                // '代理首页',
                path: 'index/index',
                component: () => import('@/pages/granary/index/index.vue')
            },

            {
                // '需求清单',
                path: 'need/xu',
                component: () => import('@/pages/granary/need/xu.vue'),
                meta: {
                    title: '仓库-需求清单'
                },
            },

            {
                // '需求清单',
                path: 'need/xuList/:orderId',
                component: () => import('@/pages/granary/need/xuList.vue'),
                meta: {
                    title: '仓库-需求列表'
                },
            },

            {
                // '物料库存',
                path: 'supplies/keep',
                component: () => import('@/pages/granary/supplies/keep.vue'),
                meta: {
                    title: '仓库-物料库存'
                },
            },

            {
                // '物料记录',
                path: 'supplies/log/:infoId',
                component: () => import('@/pages/granary/supplies/log.vue'),
                meta: {
                    title: '仓库-物料记录'
                },
            },

            {
                // '店铺物料',
                path: 'supplies/shop/:infoId',
                component: () => import('@/pages/granary/supplies/shop.vue'),
                meta: {
                    title: '仓库-店铺物料'
                },
            },

            {
                // '分拣人员',
                path: 'sorting/log/user/user',
                component: () => import('@/pages/granary/sorting/log/user/user.vue'),
                meta: {
                    title: '仓库-分拣记录'
                },
            },

            {
                // '分拣记录',
                path: 'sorting/log/user/rule/:uid/:batch',
                component: () => import('@/pages/granary/sorting/log/user/rule.vue'),
                meta: {
                    title: '仓库-分拣记录'
                },
            },

            {
                // '分拣记录',
                path: 'sorting/log/user/rule/:uid/:batch/:rid',
                component: () => import('@/pages/granary/sorting/log/user/rule.vue'),
                meta: {
                    title: '仓库-分拣记录'
                },
            },

            {
                // '分拣人员',
                path: 'sorting/log/rule/rule',
                component: () => import('@/pages/granary/sorting/log/rule/rule.vue'),
                meta: {
                    title: '仓库-分拣记录'
                },
            },

            {
                // '分拣人员',
                path: 'sorting/log/rule/user/:rid/:batch',
                component: () => import('@/pages/granary/sorting/log/rule/user.vue'),
                meta: {
                    title: '仓库-分拣记录'
                },
            },

            // --------------------------------------------------

            {
                // '装车人员',
                path: 'driver/log/user/user',
                component: () => import('@/pages/granary/driver/log/user/user.vue'),
                meta: {
                    title: '仓库-装车记录'
                },
            },

            {
                // '装车记录',
                path: 'driver/log/user/rule/:uid/:batch',
                component: () => import('@/pages/granary/driver/log/user/rule.vue'),
                meta: {
                    title: '仓库-装车记录'
                },
            },

            {
                // '装车记录',
                path: 'driver/log/user/rule/:uid/:batch/:rid',
                component: () => import('@/pages/granary/driver/log/user/rule.vue'),
                meta: {
                    title: '仓库-装车记录'
                },
            },

            {
                // '装车人员',
                path: 'driver/log/rule/rule',
                component: () => import('@/pages/granary/driver/log/rule/rule.vue'),
                meta: {
                    title: '仓库-装车记录'
                },
            },

            {
                // '装车人员',
                path: 'driver/log/rule/user/:rid/:batch',
                component: () => import('@/pages/granary/driver/log/rule/user.vue'),
                meta: {
                    title: '仓库-装车记录'
                },
            },

        ],
    },

]

const router = createRouter({
    history:createWebHashHistory(),
    routes
})

// 端口 1总代理2代理3城市4仓库5供应商
router.beforeEach(async (to, from, next) => {

    console.log('----------进入路由----------',to)

    if (to.meta.title) {
        document.title = to.meta.title
    }

    var path = to.path.split('/');

    if(to.path == '/login'){
        util.loginIs(function(isLogin){

            if(isLogin){

                next(util.loginUrl(true));
                
            }else{

                next();

            }
        },false)
    }else if(path[1] == 'token'){
        next();
    }else{
        util.loginIs(function(isLogin){

            var paramsCou = 0;
            if(to.params){

                for(var k in to.params){
                    if(k != 'state' && k != 'type'){
                        paramsCou ++;
                    }
                }

            }

            path.splice(path.length - paramsCou, paramsCou);
            var urlKey = path.join('_');
            to.query.urlKey = urlKey;

            if(isLogin){

                next();

            }else{

                alert('您还没有登录, 请先登录');
                store.state.user = 0
                store.state.token = 0
                next('/login');

            }
        })
        
    }
})

export default router
